import { DateTime } from 'luxon'
import store from '@/store.js'

// Formata a data informada padronizando a time zone
// Retorna um objeto do tipo Luxon.DateTime
const dateFormat = (date, timeZone, changeZone = true) => {
  var options = {}
  options.zone = 'utc' // Padroniza pra que as zonas sejam consideradas no UTC

  if (store.getters.getLang) options.locale = store.getters.getLang.split('-')[0]

  var dateAux = DateTime.fromISO(date, options)
  if (timeZone) dateAux = dateAux.setZone(timeZone) // options.zone = timeZone
  else {
    let user = JSON.parse(localStorage.getItem('user'))
    if (user.timeZone && changeZone) dateAux = dateAux.setZone(user.timeZone) // options.zone = user.timeZone
  }
  return dateAux
}

// Formata a data informada padronizando a time zone, dando a possibilidade de escolher o formato
// Retorna um objeto do tipo String
const dateFormatString = (date, timeZone, format) => {
  var dateAux = dateFormat(date, timeZone)

  if (format) return dateAux.toFormat(format)
  else return dateAux.toLocaleString(DateTime.DATE_SHORT)
}

// Formata a data informada padronizando a time zone
// Retorna um objeto do tipo Luxon.DateTime
const dateTimeFormat = (date, timeZone) => {
  var options = {}

  if (timeZone) options.zone = timeZone

  var dateAux = DateTime.fromISO(date, options)

  return dateAux
}

// Formata a data informada padronizando a time zone, dando a possibilidade de escolher o formato
// Retorna um objeto do tipo String
const dateTimeFormatString = (date, timeZone, format, changeZone = true) => {
  var dateAux = dateFormat(date, timeZone, changeZone)

  if (format) return dateAux.toFormat(format)
  else return dateAux.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)
}

// Formata a data e hora informada, desconsiderando os segundos, padronizando a time zone, dando a possibilidade de escolher o formato
// Retorna um objeto do tipo String EX: 10/14/1983, 1:30 PM
const dateTimeShortFormatString = (date, timeZone, format, changeZone = true) => {
  var dateAux = dateFormat(date, timeZone, changeZone)

  if (format) return dateAux.toFormat(format)
  else return dateAux.toLocaleString(DateTime.DATETIME_SHORT)
}

// Formata a data com base no seguinte exemplo: Oct 14, 1983
// Retorna um objeto do tipo String
const dateFormatStringMed = (date, timeZone) => {
  var dateAux = dateFormat(date, timeZone)
  return dateAux.toLocaleString(DateTime.DATE_MED)
}

// Formata a data com base no seguinte exemplo: Octuber 14, 1983 10:20 PM
// Retorna um objeto do tipo String
const dateFormatStringFull = (date, timeZone, changeZone = true) => {
  var dateAux = dateFormat(date, timeZone, changeZone)
  return dateAux.toLocaleString(DateTime.DATETIME_MED)
}

// Retorna um objeto do tipo String
const formatHour = (date) => {
  var dateAux = dateFormat(date)
  return dateAux.toLocaleString(DateTime.TIME_SIMPLE)
}

// Formata a data com base no seguinte exemplo: Octuber 2000
// Retorna um objeto do tipo String
const dateFormatMountNameAndYear = (date, timeZone) => {
  var dateAux = dateFormat(date, timeZone)
  return dateAux.toFormat('MMMM yyyy')
}

const dateToUTC = (date) => {
  let dateAux = DateTime.fromISO(date.toISOString())

  return dateAux.toUTC()
}

// Retorna quantos dias faltam até a data esperada
// Recomenda-se que utilize um data futura
const daysToDate = (date, timeZone) => {
  const end = dateFormat(date, timeZone)
  const start = dateFormat(new Date().toISOString())

  const days = end.diff(start, 'days').toObject().days
  const roundedDays = Math.ceil(days)

  return Math.max(roundedDays, 0)
}

const getUserDateFormat = (userDateFormat) => {
  const defaultFormat = 'dd/MM/yyyy'

  if (!userDateFormat) return defaultFormat

  return userDateFormat ? userDateFormat : defaultFormat
}

const getDateFromISO = (date) => {
  return DateTime.fromISO(date, { zone: 'utc' }).toJSDate()
}

export {
  dateFormat,
  dateFormatString,
  dateTimeFormat,
  dateTimeFormatString,
  dateTimeShortFormatString,
  dateFormatStringMed,
  dateFormatStringFull,
  dateToUTC,
  formatHour,
  dateFormatMountNameAndYear,
  daysToDate,
  getUserDateFormat,
  getDateFromISO,
}
